import * as React from 'react'
import { ReactElement } from 'react'
import { Checkbox } from '@fluentui/react-components'
import FormikField, { FormikSubFieldProps } from './FormikField'
import { useFormikContext } from 'formik'
import { CheckboxProps } from '@fluentui/react-checkbox'

export default function FormikCheckboxField<Values>(props: FormikSubFieldProps<CheckboxProps, Values>): ReactElement {
    const { values } = useFormikContext<Values>()

    return (
        <FormikField<CheckboxProps, Values>
            component={Checkbox}
            {...props}
            componentProps={{ ...props.componentProps, checked: values[props.fieldName] as boolean | 'mixed' }}
        />
    )
}
